import React from "react";
import Image from "gatsby-image";
import {ArticlePhotos} from "./ArticlePhotos";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import OgImage from "../../../../assets/images/blog/article_11/aktualne-wymiary-grafik-na-facebooku_og.png";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();
  return {
    date: "24.10.2022r",
    category: "social media, Facebook",
    title:
      <>Aktualne wymiary grafik na Facebooku <br/>[Aktualizacja: Październik 2022]</>,
    SEO_title:
      "Aktualne wymiary grafik na Facebooku",
    description:
      "To, że media społecznościowe rządzą się swoimi prawami, wiedzą wszyscy. Dostosowanie treści do obrazu to kluczowy element, który pozwala na skuteczną komunikację z odbiorcami. Na różnych platformach social media niektóre formaty i proporcje prezentują się lepiej i skuteczniej przemawiają do użytkowników. A ponieważ wymiary grafik ciągle się zmieniają, warto znać aktualne, by uniknąć automatycznego kadrowania przez portale społecznościowe.Powodem ciągłych aktualizacji są zmiany technologiczne i wprowadzanie nowych funkcji. Wymagają one modyfikacji wymiarów grafik. Dlatego przygotowaliśmy krótką ściągę, która ułatwi funkcjonowanie w social mediach.",
    seo:
      "To, że media społecznościowe rządzą się swoimi prawami, wiedzą wszyscy. Dostosowanie treści do obrazu to kluczowy element, który pozwala na skuteczną komunikację z odbiorcami.",
    slug: "/blog/aktualne-wymiary-grafik-na-facebooku",
    image: OgImage,
    authors: [
      authors.DariaPyziak,
      authors.AlexMechew
    ],
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        text:
          "Podane wymiary grafik na Facebooku są rekomendowane przez portal. Wiemy jednak, że nie zawsze sprawdzają się one najlepiej. Dlatego podajemy również te, które wykorzystuje i poleca InteractiveVision.",
      },
      second: {
        title: "Jaki rozmiar mają obrazy na Facebooku?",
        text: "Facebook to portal społecznościowy, w którym wymiary grafik zmieniają się najczęściej. Dostosowanie obrazu do odpowiedniego formatu zagwarantuje prawidłowe wyświetlanie zdjęć i filmów. Ponieważ serwis ten oferuje różne formaty reklamowe, prezentują się one w inny sposób. Uniemożliwia to przygotowanie jednej grafiki, która będzie pasowała do każdego działania marketingowego.",
      },
      third: {
        title: "Zdjęcie profilowe",
        text: "Zdjęcia profilowe na Facebooku funkcjonują w kształcie kwadratu, jednak wyświetlane są w postaci okręgu. Dlatego dodając zdjęcie, warto zwrócić uwagę, czy kluczowe elementy są widoczne i nic nie zostało przycięte. Taki obraz powinien być zeskalowany do wymiaru 170 x 170 px na urządzeniach stacjonarnych, 128 x 128 px na smartfonie i 36 x 36 px na innych telefonach."
      },
      fourth: {
        title: "InteractiveVision poleca",
        text: "Użycie zdjęcia w rozmiarze 1000x1000 pozwoli na wyświetlenie go w dobrej jakości, nawet po jego powiększeniu."
      },
      fifth: {
        title: "Zdjęcie w tle",
        text: "Wymiary zdjęcia w tle (cover photo) na Facebooku to 820 x 312 px. Na urządzeniach mobilnych obrazy te są kadrowane centralnie. Wyświetlają się w rozmiarze 640 x 360 px."
      },
      sixth: {
        title: "InteractiveVision poleca:",
        text: <>
          Rozmiar 1609x707 to połączenie wymiaru na desktop i mobile. Na grafice poniżej znajdziesz instrukcję z wyznaczonymi <b>SAFE ZONE</b>, tak aby zdjęcie w tle wyglądało dobrze na wszystkich urządzeniach.
        </>
      },
      seventh: {
        title: "Zdjęcie w tle grupy",
        text: "Grupa na FB to miejsce, które zrzesza użytkowników i usprawnia komunikację między nimi. Rekomendowany rozmiar to 1640 x 856 px (albo współczynnik 1,91:1)."
      },
      eighth: {
        title: "InteractiveVision poleca:",
        text: "Wszystkie najważniejsze informacje zamieszczaj na środku, aby zapobiec przycięcia przy bokach grafiki.",
      },
      ninth: {
        title: "Zdjęcie w tle wydarzenia",
        text: "Utworzenie wydarzenia na Facebooku to jeden z lepszych sposobów na promocję eventu. Jako cover photo Facebook zaleca stosowanie grafik o wymiarach 1200 x 628 px."
      },
      tenth: {
        title: "InteractiveVision poleca:",
        text: "Podobnie jak przy zdjęciu w tle grupy, tak i w tym przypadku najważniejsze informacje warto wyeksponować w centrum grafiki."
      },
      eleventh: {
        title: "Post pionowy 3:2",
        text: "Orientacja pionowa najlepiej sprawdza się na urządzeniach mobilnych, ponieważ rozdzielczość jest dopasowana do całego ekranu. W tym przypadku należy stosować wymiary 1080 x 1350 px."
      },
      twelfth: {
        title: "Post poziomy",
        text: "Posty poziome to jedne z najczęściej używanych formatów publikowanych postów na Facebooku. Grafiki tego typu najlepiej prezentują się w rozmiarze 1200 x 900 px."
      },
      thirteenth: {
        title: "Post kwadratowy",
        text: "Trzecim typem popularnych postów na Facebooku są te w formie kwadratu. Ich wymiar to 1200 x 1200 px."
      },
      fourteenth: {
        title: "InteractiveVision poleca:",
        text: "Najczęściej wybierany przez nas wymiar to 1200x1200. Dobrze się wyświetla na każdym urządzeniu i nadaje się do każdego rodzaju postów. Ale... Eksperymentuj! Facebook to dynamicznie zmieniająca się platforma. Jednego dnia ten wymiar będzie idealny, ale następnego wszystko może się zmienić!"
      },
      fifteenth: {
        title: "Post z karuzelą",
        text: "Jeżeli chcesz zaprezentować swoje produkty online, to najlepszym rozwiązaniem będzie karuzela. Kilka grafik w wymiarach 1080 x 1080 px skutecznie zaprezentuje wszystko, co chcesz sprzedać."
      },
      sixteenth: {
        title: "InteractiveVision poleca:",
        text: "Post z karuzelą utwórz przez Menedżer Reklam. Aktualnie to jedyny sposób, aby opublikować post tego rodzaju."
      },
      seventeenth: {
        title: "Wymiary grafik do Facebook Stories",
        text: "Relacje na Facebooku są dobrym sposobem na przekazanie krótkich komunikatów lub nawiązanie interakcji z odbiorcami. Najlepszy wymiar według serwisu to 1080 x 1920 px."
      },
      eighteenth: {
        title: "InteractiveVision poleca:",
        text: "  Przeplataj grafiki z własnymi nagraniami, używaj stickerów, oznaczeń, gifów i wszystkiego, co znajdziesz podczas publikacji relacji. Przyciągaj wzrok Twoich odbiorców."
      },
    },
    list: {
      first: {
        title: "Zanim zaczniesz skalować obrazy, pamiętaj, że…",
        content: [
          "Najlepsza rozdzielczość grafik w social mediach to 72dpi,",
          "Waga grafiki powinna zmieścić się w przedziale 100-350kB,",
          "Niewiele osób zainteresuje się Twoją grafiką, jeśli będzie na niej więcej niż 20% tekstu,",
          "Format .png to format, który jest niezastąpiony w mediach społecznościowych,",
          "Obrazy najlepiej prezentują się w profilu kolorów sRGB.",
        ]
      }
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
      fourth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_4.childImageSharp.fluid}
        />
      ),
      fifth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_5.childImageSharp.fluid}
        />
      ),
      sixth: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_6.childImageSharp.fluid}
        />
      ),
      seventh: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_7.childImageSharp.fluid}
        />
      ),
    },
    ending: "Życzymy miłego skalowania obrazów!"
  };
};
